import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  RESET_ACTIVE,
  UPDATE_ACTIVE,
  UPDATE_REPORT_BODY,
  UPDATE_REPORT_URL,
  RESET_PAGE,
  UPDATE_PAGE,
  PAGE,
  NEW_REVISION_NAME_CHANGE,
  ADD_FILES,
  NEW_REVISION_NAME_CLEAR,
  CLEAR_ADD_FILES,
  TOGGLE_NVBUG_CHECKBOX
} from './constants'

const resetActive = () => false
const updateActive = (prev, { active }) => active
const reportBodyEmptyString = () => 'No report request submitted. Please upload NVQual spreadsheet to continue.'
const reportUrlEmptyString = () => ''

const resetPage = () => PAGE.FILE_SELECTION
const updatePage = (prev, { page }) => page

const activeReducer = createReducer(false, {
  [RESET_ACTIVE]: resetActive,
  [UPDATE_ACTIVE]: updateActive
})

const pageReducer = createReducer(resetPage(), {
  [RESET_PAGE]: resetPage,
  [UPDATE_PAGE]: updatePage
})


const reportBodyReducer = createReducer(reportBodyEmptyString(), {
  [UPDATE_REPORT_BODY]: (prev, { value }) => value
})

const reportUrlReducer = createReducer(reportUrlEmptyString(), {
  [UPDATE_REPORT_URL]: (prev, { value }) => value
})

const newRevisionNameReducer = createReducer('', {
  [NEW_REVISION_NAME_CHANGE]: (prev, { newName }) => newName,
  [NEW_REVISION_NAME_CLEAR]: () => ''
})

const filesReducer = createReducer([], {
  [ADD_FILES]: (prev, { files }) => files,
  [CLEAR_ADD_FILES]: () => []
})

const createNvbugReducer = createReducer(false, {
  [TOGGLE_NVBUG_CHECKBOX]: (prev) => !prev,
  [CLEAR_ADD_FILES]: () => false
})

export default combineReducers({
  active: activeReducer,
  reportBody: reportBodyReducer,
  reportUrl: reportUrlReducer,
  page: pageReducer,
  newRevisionName: newRevisionNameReducer,
  files: filesReducer,
  createNvbug: createNvbugReducer
})
